module.exports = __webpack_public_path__ + "media/punisher-example.1e21ae69.mp4";